//@flow
import * as Immutable from 'immutable';

import {
    CityId,
    AutoSortAddress,
    AutoSortRequest
} from 'common/models/flow/AutoSortRequest';
import type {
    CityIdModelType,
    AutoSortAddressModelType,
    AutoSortRequestModelType
} from 'common/models/flow/AutoSortRequest';
import { VersionedMapId } from './VersionedMapId';

class InternalCityId extends CityId {
    static fromJS(json: CityIdModelType): InternalCityId {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }
}

class InternalAutoSortAddress extends AutoSortAddress {
    static fromJS(json: AutoSortAddressModelType): InternalAutoSortAddress {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }
}

class InternalAutoSortRequest extends AutoSortRequest {
    static fromJS(json: AutoSortRequestModelType): InternalAutoSortRequest {
        const state: Object = Object.assign({}, json);
        state.cityId = InternalCityId.fromJS(state.cityId);
        state.address = InternalAutoSortAddress.fromJS(state.address);
        state.versionedMapIds = Immutable.List(
            state.versionedMapIds
        ).map(item => VersionedMapId.fromJS(item));
        return new this(Immutable.Map(state));
    }

    get cityId(): InternalCityId {
        return this._state.get('cityId');
    }

    get address(): InternalAutoSortAddress {
        return this._state.get('address');
    }

    get versionedMapIds(): Immutable.List<VersionedMapId> {
        return this._state.get('versionedMapIds');
    }
}

export {
    InternalCityId as CityId,
    InternalAutoSortAddress as AutoSortAddress,
    InternalAutoSortRequest as AutoSortRequest
};
